import { render } from "./CaseManager.vue?vue&type=template&id=b7c23622&scoped=true"
import script from "./CaseManager.vue?vue&type=script&lang=js"
export * from "./CaseManager.vue?vue&type=script&lang=js"

import "./CaseManager.vue?vue&type=style&index=0&id=b7c23622&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c23622"]])

export default __exports__